export const innerRenderPaths = {
  1: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender1.jpeg",
  2: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender2.jpeg",
  3: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender3.jpeg",
  4: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender4.jpeg",
  5: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender5.jpeg",
  6: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender6.jpeg",
  7: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender7.jpeg",
  8: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender8.jpeg",
  9: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender9.jpeg",
  10: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender10.jpeg",
  11: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender11.jpeg",
  12: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender12.jpeg",
  13: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/innerRender13.jpeg",
};

export const greenHomeOutterRenderPaths = {
  roadView:
    "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/%E1%83%90%E1%83%95%E1%83%A2%E1%83%9D%E1%83%A5%E1%83%90%E1%83%A0%E1%83%AE%E1%83%90%E1%83%9C%E1%83%90%20%E1%83%92%E1%83%96%E1%83%98%E1%83%A1%20%E1%83%AE%E1%83%94%E1%83%93%E1%83%98.png",
  light:
    "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/%E1%83%90%E1%83%95%E1%83%A2%E1%83%9D%E1%83%A5%E1%83%90%E1%83%A0%E1%83%AE%E1%83%90%E1%83%9C%E1%83%90%20light.png",
  photo1:
    "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/%E1%83%90%E1%83%95%E1%83%A2%E1%83%9D%E1%83%A5%E1%83%90%E1%83%A0%E1%83%AE%E1%83%90%E1%83%9C%E1%83%90%20%E1%83%A4%E1%83%9D%E1%83%A2%E1%83%9D%E1%83%A0%E1%83%94%E1%83%9C%E1%83%93%E1%83%94%E1%83%A0%E1%83%98.png",
  photo2:
    "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/%E1%83%90%E1%83%95%E1%83%A2%E1%83%9D%E1%83%A5%E1%83%90%E1%83%A0%E1%83%AE%E1%83%90%E1%83%9C%E1%83%90%20%E1%83%A4%E1%83%9D%E1%83%A2%E1%83%9D%E1%83%A0%E1%83%94%E1%83%9C%E1%83%93%E1%83%94%E1%83%A0%E1%83%98%20nata.png",
  dark: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/%E1%83%A6%E1%83%9B%E1%83%98%E1%83%A1%20%E1%83%AE%E1%83%94%E1%83%93%E1%83%98%20%E1%83%9B%E1%83%A3%E1%83%A5%E1%83%98.png",
};

export const staffImageData = {
  staff:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/staff.jpeg",
  anaBregadze:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/AnaBregadze.png",
  davitKldiashvili:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/DavitKldiashvili.png",
  diomidePkhakadze:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/DiomidePkhakadze.png",
  giorgiDarsavelidze:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/GiorgiDarsavelidze.png",
  giorgiKvitivadze:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/GiorgiKvitivadze.png",
  guramKobakhidze:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/GuramKobakhidze.png",
  gvantsaIobidze:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/GvantsaIobidze.png",
  megiChkhetiani:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/MegiChkhetiani.png",
  nataShavlakadze:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/NataShavlakadze.png",
  tengizShavishvili:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/TengizShavishvili.png",
  titiErkomashvili:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/TitiErkomashvili.png",  
}
export const newsImageData = {
  herroLargeScreen:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/newsHomePageLargeScreen.jpg",
  herroSmallScreen:"https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/newsHomePageSmallScreen.jpeg"
}
